import { Ptag } from "components/core";
import React from "react";
import { Dependent, DependentsWrapper } from "../styles";
import { formatNumberToIndian, formatRelationship } from "utlis/utils";
import useMemberAvatar from "hooks/useMemberAvatar";
import HeartIcon from "assets/svgs/heart.svg";
import maleIcon from "assets/svgs/avatars/male.svg";
import femaleIcon from "assets/svgs/avatars/female.svg";
import sonIcon from "assets/svgs/avatars/son.svg";
import daughterIcon from "assets/svgs/avatars/daughter.svg";
import grandFatherIcon from "assets/svgs/avatars/grandfather.svg";
import grandMotherIcon from "assets/svgs/avatars/grandmother.svg";
import fatherInLaw from "assets/svgs/avatars/father-in-law.png";
import motherInLaw from "assets/svgs/avatars/mother-in-law.png";

function ProductDetailCardDependents({ dependents }) {
  const { avatar } = useMemberAvatar({ background: "#FDF2E1" });
  if (!dependents) return null;

  const sortedDependents = Object.entries(dependents).sort(([key1], [key2]) => {
    if (key1 === "SELF") {
      return -1;
    }
    if (key2 === "SELF") {
      return 1;
    }
    return 0;
  });

  const svgByDependent = (key) => {
    if (key === "SELF") {
      return maleIcon;
    } else if (key === "MOTHER") {
      return grandMotherIcon;
    } else if (key === "SON") {
      return sonIcon;
    } else if (key === "DAUGHTER") {
      return daughterIcon;
    } else if (key === "SPOUSE") {
      return femaleIcon;
    } else if (key === "FATHER") {
      return grandFatherIcon;
    } else if (key === "FATHERINLAW") {
      return fatherInLaw;
    } else if (key === "MOTHERINLAW") {
      return motherInLaw;
    } else {
      return HeartIcon;
    }
  };

  const sortFamilyData = (data) => {
    const order = [
      "SELF",
      "SPOUSE",
      "SON",
      "DAUGHTER",
      "MOTHER",
      "FATHER",
      "MOTHERINLAW",
      "FATHERINLAW",
    ];
    try {
      return data.sort((a, b) => {
        return order.indexOf(a[0]) - order.indexOf(b[0]);
      });
    } catch (error) {
      console.error("Dependents Sorting error:", error);
      return data;
    }
  };

  const renderDependent = (key, value) => (
    <Dependent key={key}>
      <div>
        <img
          src={svgByDependent(key)}
          style={{ width: "30px", height: "30px", padding: "3px 2px 2px 2px" }}
          alt=""
        />
      </div>
      <div>
        <Ptag
          color="#646075"
          fontSize="14px"
          marginBottom="4px"
          style={{
            whiteSpace: "nowrap",
          }}
        >
          {formatRelationship(key)}
        </Ptag>
        <Ptag fontWeight="700" fontSize="16px">
          {formatNumberToIndian(value)}
        </Ptag>
      </div>
    </Dependent>
  );
  return (
    <DependentsWrapper>
      {console.log("data ===>", sortedDependents)}
      {sortFamilyData(sortedDependents).map(([key, value]) =>
        renderDependent(key, value)
      )}
    </DependentsWrapper>
  );
}

export default ProductDetailCardDependents;
